import { Validators } from "@angular/forms"
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { EPolicyTypes, IPolicyFunds } from "src/app/modules/shared/models/policy.model"
import { ILifeFund } from "../../athora.constants"

export const payment_form_template = {
    paymentMode: {value:'C/C Bancario', disabled: true},
    iban: '',
    amount: ''
}

export const payment_form_validators = {
    paymentMode: [Validators.required],
    iban: [Validators.required],
    amount: [Validators.required]
}

export const payment_form_keys: IFormKey[] = [
    {
        id: 'payment-mode-field',
        label: 'Modalità di addebito',
        controlName: 'paymentMode',
        css: 'col-3',
        readonly: true
    },
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'amount-field',
        label: 'Premio lordo',
        controlName: 'amount',
        type: 'INPUT',
        css: 'col-3',
        isAmountField: true
    }
]

export const POLICY_TYPES_WITH_FUNDS = [
    EPolicyTypes.MULTIRAMO,
    EPolicyTypes.UNIT
]

export interface IVersamentoAggiuntivoRequest {
    policyNumber: string;
    ibanVersamentoAggiuntivo?: string;
    numeroRapporto?: string;
    importoPremioU740?: string;
    importoPremioU744?: string;
    importoPremioU748?: string;
    importoPremioV740?: string;
    importoPremioV744?: string;
    importoPremioV748?: string;
    importoPremio?: string;
    lifeInvestments?: ILifeFund[];
    ndgTutoreODelegato?: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
}

export interface IVersamentoAggiuntivoFunds extends IPolicyFunds {
    offset?: number;
}

export const ADDITIONAL_PAYMENTS_ASSETS_TABLE_TABLE_KEYS: ITableKey[] = [
    {
        key: 'attributeDescription',
        label: 'Nome fondo'
    },
    {
        key: 'amount',
        label: 'Importo da investire (€)'
    }
]
